'use client';

import { createContext } from 'react';
import { ELanguage } from '../../Utils/constants.js';

var ResumeModalContext = createContext({
    t: function () { return ''; },
    lang: ELanguage.VI,
    isShowLoading: false,
    setShowLoading: function () { },
    isUploading: false,
    setIsUploading: function () { },
    uploadFile: undefined,
    setUploadFile: function () { },
    step: 1,
    setStep: function () { }
});

export { ResumeModalContext as default };
//# sourceMappingURL=index.js.map
